import { render, staticRenderFns } from "./FacebookServiceDetails.vue?vue&type=template&id=f27af63c"
import script from "./FacebookServiceDetails.vue?vue&type=script&lang=js"
export * from "./FacebookServiceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports